module.exports = __webpack_public_path__ + "img/trade-icon-1.e112ec29.svg";